module.exports = __webpack_public_path__ + "static/media/courierfreight.4823b1ee.xlsx";